import { AnimalBase } from 'api/query/shared';
import { Exclude, Expose, Type } from 'class-transformer';
import { PedigreeVisibility } from '../shared/pedigree-visibility-enum';
import { Trait } from '../shared/trait';

@Exclude()
export class SearchAnimal implements AnimalBase {
  @Expose()
  animalId: string;

  @Expose()
  studId: string;

  @Expose()
  damAnimalId: string;

  @Expose()
  damVisibility: PedigreeVisibility;

  @Expose()
  sireAnimalId: string;

  @Expose()
  sireVisibility: PedigreeVisibility;

  @Expose()
  isMss: boolean;

  @Expose()
  isDna: boolean;

  @Expose()
  semenAvailable: boolean;

  @Expose()
  forSale: boolean;

  @Expose()
  sireInRefFlock: boolean;

  @Expose()
  sireInCpt: boolean;

  @Expose()
  isRegistered: boolean;

  @Expose()
  isMlp: boolean;

  @Expose()
  @Type(() => Trait)
  asbvs: Trait[];

  @Expose()
  searchKey: string;
}
